import PropTypes from "prop-types";

import { withTranslation } from "react-i18next";
import { Card, Container, Row, Spinner } from "reactstrap";
import { useSelector } from "react-redux";

import logoLightSvg from "../../../assets/images/logo-sm-light.svg";
import darkLogo from "../../../assets/images/logo-sm-dark.png";

const Loading = ({ t }) => {
  const { mainTheme } = useSelector((state) => state.Layout);

  return (
    <Container className="w-100 vh-100 d-flex flex-column justify-content-center align-items-center">
      <Card className="w-25 p-4 mb-3">
        <Row className="justify-content-center">
          <Spinner color="primary" size="sm" className="mb-2" />
        </Row>
        <Row className="justify-content-center text-center">
          {t("Loading SSO")}
        </Row>
      </Card>
      <img
        src={mainTheme === "dark" ? logoLightSvg : darkLogo}
        alt="Tech4 logo"
        width={32}
        height={32}
      />
    </Container>
  );
};

Loading.propTypes = {
  t: PropTypes.func,
};

export default withTranslation()(Loading);
